module.exports = __webpack_public_path__ + "img/division.3dd46da3.png";